export default "__VITE_ASSET__BKvDNw8M__"